import React from 'react';
import * as EventosEquipos from '../constantes/EventosEquiposTorneos.js';
import * as Iconos from '../UI/Iconos.js';
import styles from './Iconos.module.css';

export const IconoTitulo = (props) => {
  const objeto = props.objeto;

  let source = null;
  let alt = null;
  if (objeto && objeto.tituloObtenido) {
    if (objeto.tituloObtenido === EventosEquipos.CAMPEON) {
      source = Iconos.campeon;
      alt = 'Campeón';
    } else if (objeto.tituloObtenido === EventosEquipos.SUBCAMPEON) {
      source = Iconos.subCampeon;
      alt = 'Subcampeón';
    }
  }

  return (
    <React.Fragment>
      {source && (
        <img
          className={`${styles.iconoTitulo}`}
          src={source}
          id={objeto.id}
          key={alt + objeto.id}
          alt={alt}
        />
      )}
    </React.Fragment>
  );
};

export default IconoTitulo;
